export type { CheckPriceProps } from "./checkPriceConstants";
export { useExistingProductState } from "./hooks/checkPriceHooks";

import { CheckPrice } from "./CheckPrice";
export default CheckPrice;
